export enum AppPaths {
  CALL_FORM = '',
  DOCUMENTATION_FORM = 'documentation',
  MESSAGE = 'message',
  APPOINTMENT = 'appointment',
  CANCEL_FORM = 'cancel',
  MEDICAL_RECORDS_CONFIRMATION = 'confirmation-sending',
  RATE = 'rate',
  ADDRESS_FORM = 'address',
}
